import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter"

export const getSearchClient = lang => {
  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: process.env.GATSBY_TYPESENSE_SEARCH_KEY,
      nodes: [
        {
          host: process.env.GATSBY_TYPESENSE_HOST,
          port: process.env.GATSBY_TYPESENSE_PORT,
          protocol: process.env.GATSBY_TYPESENSE_PROTOCOL,
        },
      ],
    },
    additionalSearchParameters: {
      query_by: "title,body",
      stopwords: lang,
    },
  })

  return typesenseInstantsearchAdapter.searchClient
}

export const AUTOCOMPLETE_SEARCH_DELAY_MS = 300
export const AUTOCOMPLETE_RESULTS_PER_PAGE = 5
export const AUTOCOMPLETE_MIN_CHARS = 3
export const RESULTS_PER_PAGE = 10
